export const padDateParts = (n: number) => n.toString().padStart(2, '0');

export const formatForInput = (dateString: string, type: "datetime-local" | "date" | "time"): string => {
  if (!dateString) return "";
  try {
    const d = new Date(dateString);
    if (isNaN(d.getTime())) return dateString;

    const yyyy = d.getFullYear();
    const mm = padDateParts(d.getMonth() + 1);
    const dd = padDateParts(d.getDate());
    const hh = padDateParts(d.getHours());
    const min = padDateParts(d.getMinutes());

    if (type === "datetime-local") return `${yyyy}-${mm}-${dd}T${hh}:${min}`;
    if (type === "date") return `${yyyy}-${mm}-${dd}`;
    if (type === "time") return `${hh}:${min}`;
  } catch (e) {
    // Return original string if parsing fails
  }
  return dateString;
};